import type { LoginOrSignupState } from '#src/app/pages/loginOrSignup/shared/types';
import { getStepValidator } from '#src/app/pages/loginOrSignup/shared/utilities';

import { toggleFormFieldsValidity } from './toggleFormFieldsValidity';

export function validateCurrentStepFormFields(state: LoginOrSignupState): LoginOrSignupState {
	const validator = getStepValidator(state.currentStep);
	return toggleFormFieldsValidity(state, validator(state));
}
